export default __webpack_public_path__ + "static/media/first_class.5edfb43c.jpg";